import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs },
} = constants.breakpoints;
const { ui } = constants.colors;
const { fontFamily } = typographyStyles;

const white = ui.white[500];
const neutral400 = ui.neutral[400];
const neutral700 = ui.neutral[700];

export const buttonCss = (isSelected) => {
  return {
    fontSize: "14px",
    lineHeight: "114%",
    padding: "8px",
    color: isSelected ? white : neutral400,
    ...(isSelected && { backgroundColor: neutral700 }),
    border: `1px solid ${isSelected ? neutral700 : "transparent"}`,
    borderRadius: "40px",
    fontFamily: fontFamily.circular,
    fontWeight: "700",
    whiteSpace: "nowrap",
    "&:hover": {
      ...(isSelected && { backgroundColor: neutral700 }),
    },

    [mq.downTo(xs)]: {
      fontSize: "16px",
      lineHeight: "150%",
      fontFamily: fontFamily.circular,
      padding: "6px 24px",
    },
  };
};
